<template>
  <div class="fff">
    <div class="page_title">
      {{ $t("enter.tips") }}
    </div>
    <div class="Enter">
      <div>{{ $t("enter.id") }}</div>
      <input v-model="key.apple_id" :placeholder="$t('enter.placeholder')" />
    </div>
    <div class="Enter">
      <div>{{ $t("enter.password") }}</div>
      <input
        v-model="key.apple_pwd"
        :type="isshow ? 'password' : ''"
        :placeholder="$t('enter.placeholder1')"
      />
      <img
        v-if="!isshow"
        @click="isshow = !isshow"
        src="@/assets/img/ege.png"
        alt=""
      />
      <img
        v-if="isshow"
        @click="isshow = !isshow"
        src="@/assets/img/ege1.png"
        alt=""
      />
    </div>
    <div class="twoButton">
      <div @click="$router.go(-1)" class="BackButton">
        {{ $t("enter.back") }}
      </div>
      <div
        @click="getup()"
        :class="['loginButton', countDown < 60 ? 'disabled' : '']"
      >
        <span v-if="countDown < 60">{{ countDown }}s</span>
        <span v-else>{{ $t("enter.continue") }}</span>
      </div>
    </div>
    <div class="Popup syy" v-if="isshow1">
      <div class="Popups_w" @click="isshow1 = false">></div>
      <div class="Popups">
        <img @click="isshow1 = false" src="@/assets/img/x.png" class="close" />
        <div class="Popups_title helvetica">
          {{ $t("enter.noBackup") }}
        </div>
        <div class="Popups_con helvetica">
          {{ $t("enter.toBackup") }}
        </div>
        <div class="Verification_ul">
          <div
            :class="msg == 0 ? 'Verification_li mr' : 'Verification_li left'"
          >
            <div class="Verification_li_title helvetica">
              {{ $t("enter.tips1") }}
            </div>
            <div class="Verification_li_img">
              <img src="static/img/1.jpg" />
            </div>
          </div>
          <div
            :class="
              msg == 1
                ? 'Verification_li mr'
                : msg < 1
                ? 'Verification_li right'
                : 'Verification_li left'
            "
          >
            <div class="Verification_li_title helvetica">
              {{ $t("enter.tips2") }}
            </div>
            <div class="Verification_li_img">
              <img src="static/img/2.jpg" />
            </div>
          </div>
          <div
            :class="
              msg == 2
                ? 'Verification_li mr'
                : msg < 2
                ? 'Verification_li right'
                : 'Verification_li left'
            "
          >
            <div class="Verification_li_title helvetica">
              {{ $t("enter.tips3") }}
            </div>
            <div class="Verification_li_img">
              <img src="static/img/3.jpg" />
            </div>
          </div>
          <div
            :class="
              msg == 3
                ? 'Verification_li mr'
                : msg < 3
                ? 'Verification_li right'
                : 'Verification_li left'
            "
          >
            <div class="Verification_li_title helvetica">
              {{ $t("enter.tips4") }}
            </div>
            <div class="Verification_li_img">
              <img src="static/img/4.jpg" />
            </div>
          </div>
          <div
            :class="
              msg == 4
                ? 'Verification_li mr'
                : msg < 4
                ? 'Verification_li right'
                : 'Verification_li left'
            "
          >
            <div class="Verification_li_title helvetica">
              {{ $t("enter.tips5") }}
            </div>
            <div class="Verification_li_img">
              <img src="static/img/5.jpg" />
            </div>
          </div>
        </div>
        <div class="lORr">
          <div class="helvetica" @click="msg = msg - 1" v-if="msg > 0">
            <img src="@/assets/img/go_l.png" />{{ $t("enter.back") }}
          </div>
          <div v-if="msg == 0"></div>
          <div>{{ msg + 1 }}/5</div>
          <div
            class="helvetica"
            v-if="msg < 4"
            @click="msg < 4 ? (msg = msg + 1) : ''"
          >
            {{ $t("enter.next") }}<img src="@/assets/img/go_r.png" />
          </div>
        </div>
        <div></div>
        <div @click="$router.push({ name: 'ok' })" class="loginButton">
          {{ $t("enter.ok") }}
        </div>
      </div>
    </div>
    <Oops ref="oops" @init="setOutdate"></Oops>
    <sign-in-retry-dialog
      v-model="retryDialogVisible"
      :status="retryDialogStatus"
      @edit="onEditCredential"
      @retry="onRetrySignIn"
    />
    <SignInToICloudDialog v-model="icloudDialogVisible" />
  </div>
</template>

<script>
import { BinddeviceBindApple } from "@/api/user";
import Oops from "./Oops";
import SignInRetryDialog from "./SignInRetryDialog";
import SignInToICloudDialog from "./SignInToICloudDialog";
export default {
  components: {
    Oops,
    SignInRetryDialog,
    SignInToICloudDialog,
  },
  name: "HelloWorld",
  data() {
    return {
      key: {
        equipment_id: localStorage.getItem("systemId"),
        user_id: localStorage.getItem("id"),
        apple_id: "",
        apple_pwd: "",
      },
      systemlist: [],
      Password: "",
      isshow: true,
      isshow1: false,
      msg: 0,
      countDown: 60,
      timer: null,
      isDisabled: false,
      retryDialogVisible: false,
      retryDialogStatus: "failed",
      icloudDialogVisible: false,
    };
  },
  mounted() {},
  watch: {
    countDown(value) {
      if (value <= 0) {
        clearInterval(this.timer);
        this.timer = null;
        this.countDown = 60;
      }
    },
  },
  methods: {
    setOutdate() {
      let systemId = localStorage.getItem("systemId");
      let temp = this.systemlist.find((item) => item.id === Number(systemId));
      if (temp) {
        temp.apple_is_outdate = 0;
      }
    },
    // 点击"编辑账号密码"→ 关闭弹窗，留在当前页修改
    onEditCredential() {
      this.retryDialogVisible = false;
    },
    // 冷却结束后点击"Try again"→ 切换重试中状态，重新调用绑定接口
    onRetrySignIn() {
      this.retryDialogStatus = "retrying";
      const params = {
        ...this.key,
        is_retry: 1,
        is_resend: 1,
      };
      BinddeviceBindApple(params)
        .then((adj) => {
          this.retryDialogVisible = false;
          if (adj.code === 0) {
            this.$message.error(adj.msg);
          } else if (adj.code === 1001) {
            // 再次失败 → 重新弹出冷却弹窗
            this.retryDialogStatus = "failed";
            this.retryDialogVisible = true;
          } else if (adj.code === 1003) {
            // 需先去 iCloud.com 登录 → 弹出引导弹窗
            this.icloudDialogVisible = true;
          } else if (adj.code === 1 || adj.code === 2) {
            this.$router.push({ name: "Allow", params: this.key });
          } else if (adj.code === 10 || adj.code === 11) {
            localStorage.setItem(
              "cachedDeviceList",
              JSON.stringify(adj.data)
            );
            this.$router.push({ name: "SelectTheDevice" });
          } else {
            this.isshow1 = true;
          }
        })
        .catch(() => {
          this.retryDialogVisible = false;
          this.$message.error(this.$t("signInRetry.failedTitle"));
        });
    },
    getup() {
      if (!this.isDisabled && this.countDown === 60) {
        this.isDisabled = true;
        this.countDown -= 1;

        this.timer = setInterval(() => {
          this.countDown -= 1;
        }, 1000);

        BinddeviceBindApple(this.key)
          .then((adj) => {
            this.isDisabled = false;
            if (adj.code === 0) {
              this.$message.error(adj.msg);
              return false;
            } else if (adj.code === 1001) {
              // 账号密码验证失败 → 弹出冷却重试弹窗
              this.retryDialogStatus = "failed";
              this.retryDialogVisible = true;
            } else if (adj.code === 1003) {
              // 需先去 iCloud.com 登录 → 弹出引导弹窗
              this.icloudDialogVisible = true;
            } else if (adj.code === 1 || adj.code === 2) {
              this.$router.push({ name: "Allow", params: this.key });
            } else if (adj.code === 10 || adj.code === 11) {
              // 缓存设备列表，跳 SelectTheDevice（不带 code，让其走缓存）
              localStorage.setItem(
                "cachedDeviceList",
                JSON.stringify(adj.data)
              );
              this.$router.push({ name: "SelectTheDevice" });
            }
            // else if (adj.code === 1003 || adj.code === 1004 || adj.code === 1005) {
            //   this.$refs.oops.open();
            // }
            else {
              this.isshow1 = true;
            }
          })
          .catch(() => {
            this.isDisabled = false;
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  position: absolute;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.Enter {
  font-size: 14px;
  color: #000927;
  line-height: 20px;
  margin-left: 5%;
  width: 85%;
  max-width: 800px;
  margin-bottom: 30px;
  position: relative;
}
.Enter div {
  margin-bottom: 8px;
  height: 20px;
}
.Enter input {
  width: 400px;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  border: 1px solid #d5d7db;
  border-radius: 8px;
  text-indent: 10px;
}
.Enter img {
  position: absolute;
  left: 370px;
  width: 16px;
  height: 16px;
  top: 45px;
  cursor: pointer;
}

.Popups {
  width: 360px;
  height: 630px;
  margin: -310px -230px;
  padding: 0 50px;
  font-size: 14px;
}
.Popups_title {
  font-size: 16px;
  margin-top: 30px;
  margin-bottom: 20px;
}
.Popups_con {
  font-size: 14px;
  color: grey;
}
.lORr {
  overflow: hidden;
  position: relative;
  margin: 0 0 20px;
}
.lORr div {
  font-size: 13px;
  color: grey;
  height: 20px;
  line-height: 20px;
}
.lORr div:first-child {
  float: left;
  margin-left: 50px;
  cursor: pointer;
}
.lORr div:first-child + div {
  position: absolute;
  width: 50px;
  text-align: center;
  left: 50%;
  margin-left: -25px;
}
.lORr div:first-child + div + div {
  float: right;
  margin-right: 50px;
  cursor: pointer;
}
.lORr div img {
  width: 16px;
  height: 16px;
  float: left;
  margin: 2px;
}
.lORr div:first-child + div + div img {
  float: right;
}
.Verification_ul {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 420px;
  margin-top: 20px;
}
.Verification_ul .Verification_li {
  position: absolute;
  left: 0;
  -webkit-transition: all 0.8s;
  transition: all 0.8s;
}
.Verification_ul .Verification_li.left {
  left: -106%;
}
.Verification_ul .Verification_li.right {
  left: 106%;
}
.Verification_li_title {
  font-size: 13px;
  color: #45484d;
}
.Verification_li_img {
  width: 350px;
  height: 360px;
  margin-left: 5px;
  margin-top: 20px;
  -webkit-box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.5);
  border-radius: 22px;
  overflow: hidden;
}
.Verification_li_img img {
  width: 100%;
}
.loginButton {
  width: 270px;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
.disabled {
  background-color: #d5d7db !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Enter.vue